import { ChangeEvent } from 'react';
import { FunnelIcon, MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { Checkbox } from '@tailwindComponents/Checkbox';
import { FilterSelect } from '@tailwindComponents/FilterSelect';

export interface SupplierToolbarProps {
  searchQuery: string;
  onSearchQueryChange: (event: ChangeEvent<HTMLInputElement>) => void;
  sourceType: string | null;
  onSourceTypeChange: (value: string | null) => void;
  sourceTypeOptions: { label: string; value: string }[];
  includeArchived: boolean;
  onIncludeArchivedChange: (value: boolean) => void;
  isRailVisible: boolean;
  onToggleRail: () => void;
}

export function SupplierToolbar({
  searchQuery,
  onSearchQueryChange,
  sourceType,
  onSourceTypeChange,
  sourceTypeOptions,
  includeArchived,
  onIncludeArchivedChange,
  isRailVisible,
  onToggleRail,
}: SupplierToolbarProps) {
  return (
    <div className='flex flex-wrap items-center gap-3 font-inter'>
      <div className='relative min-w-[16rem] flex-1 sm:max-w-xs'>
        <MagnifyingGlassIcon className='absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-gray-400' />
        <input
          type='text'
          name='searchSuppliers'
          aria-label='Search suppliers'
          value={searchQuery}
          onChange={onSearchQueryChange}
          placeholder='Search suppliers...'
          className='h-9 w-full rounded-lg border border-gray-300 pl-9 pr-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-200'
        />
      </div>
      <div className='w-48'>
        <FilterSelect
          placeholder='All source types'
          options={sourceTypeOptions}
          value={sourceType}
          onChange={onSourceTypeChange}
        />
      </div>
      <button
        type='button'
        aria-pressed={isRailVisible}
        onClick={onToggleRail}
        className={`ml-auto inline-flex h-9 items-center gap-1.5 rounded-lg border px-3 text-sm font-medium transition-colors ${
          isRailVisible
            ? 'border-blue-200 bg-blue-50 text-primary'
            : 'border-gray-300 text-gray-700 hover:bg-gray-50'
        }`}
      >
        <FunnelIcon className='h-4 w-4' />
        Filters
      </button>
      <Checkbox
        label='Include archived'
        checked={includeArchived}
        onChange={(e) => onIncludeArchivedChange(e.target.checked)}
      />
    </div>
  );
}
